import { useMemo } from 'react';
import PropTypes from 'prop-types';

import { DESIGN_AUDIT_STATUS, DESIGN_AUDIT_STATUS_DISPLAY } from 'utlis/constants';

const StatusBadge = ({ status: statusProp }) => {
  const {
    circleBG,
    statusText,
  } = useMemo(() => {
    switch (statusProp) {
      case DESIGN_AUDIT_STATUS.IN_PROGRESS:
        return {
          circleBG: 'bg-yellow-400',
          statusText: DESIGN_AUDIT_STATUS_DISPLAY[DESIGN_AUDIT_STATUS.IN_PROGRESS],
        };
      case DESIGN_AUDIT_STATUS.COMPLETED:
        return {
          circleBG: 'bg-green-400',
          statusText: DESIGN_AUDIT_STATUS_DISPLAY[DESIGN_AUDIT_STATUS.COMPLETED],
        };
      case DESIGN_AUDIT_STATUS.FAILURE:
        return {
          circleBG: 'bg-red-400',
          statusText: DESIGN_AUDIT_STATUS_DISPLAY[DESIGN_AUDIT_STATUS.FAILURE],
        };
      default:
        return {
          circleBG: null,
          statusText: 'Unknown',
        };
    }
  }, [statusProp]);

  return (
    <span
      className={`
        flex items-center gap-[6px] px-2 py-[2px] rounded-full border 
        border-figma-gray-200 bg-white text-sm font-medium max-h-[24px] 
        text-figma-gray-600 px-8 py-2
      `}
    >
      {circleBG && (
        <span className={`w-2 h-2 rounded-full ${circleBG}`} />
      )}
      {statusText}
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.number.isRequired,
};

export default StatusBadge;
